import React, { Component } from 'react';
import { TextField } from '@material-ui/core';
import { getSharedTextFieldProps } from './helpers';

class ComponentTrackingInfo extends Component {
    render() {
        const { classes, editInfo, view_type } = this.props;
        if (view_type === 'create') return null;
        
        return (
            <React.Fragment>
                <TextField
                    id="CreateAuthName"
                    label="Created By"
                    value={editInfo.CreateAuthName || 'None'}
                    {...getSharedTextFieldProps('detail', classes)}
                />
                <TextField
                    id="CreationDate"
                    label="Creation Date"
                    value={this.props.editInfo.CreationDate || 'None'}
                    {...getSharedTextFieldProps('detail', classes)}
                />
                <TextField
                    id="LastEditAuthName"
                    label="Last Edit By"
                    value={this.props.editInfo.LastEditAuthName || 'None'}
                    {...getSharedTextFieldProps('detail', classes)}
                />
                <TextField
                    id="LastEditDate"
                    label="Last Edit Date"
                    value={this.props.editInfo.LastEditDate || 'None'}
                    {...getSharedTextFieldProps('detail', classes)}
                />
            </React.Fragment>
        )
    }
}

export default ComponentTrackingInfo;


// WEBPACK FOOTER //
// src/main/components/ComponentTrackingInfo.js